import {
  IonButton,
  IonContent,
  IonFooter,
  IonInput,
  IonModal,
  IonSpinner,
  IonToolbar,
  useIonToast
} from '@ionic/react'
import { ModalTitle } from 'presentation/components'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import { reportToTypeaheadItem } from '../../report-atom'
import './modal-report-issue.scss'
import { ReportStatus } from 'domain/usecases/get-report'
import { ReportsService } from 'infra/services/reports-service'
import { modalEditReportHeaderAtom, ModalEditReportHeaderState } from '../modal-edit-report-header/modal-edit-report-header-atom'
import { ReportEdition } from '../modal-edit-report-header/modal-edit-report-header'
import { warningOutline } from 'ionicons/icons'

type ModalReportIssueProps = React.ComponentPropsWithoutRef<typeof IonModal> & {
  modal: React.RefObject<HTMLIonModalElement>
  reportsService: ReportsService
  reportEdition: ReportEdition
  headerTitle: string
}

const ModalReportIssue: React.FC<ModalReportIssueProps> = (props) => {
  const [editState, setEditState] = useRecoilState(modalEditReportHeaderAtom)
  const [isSaving, setSaving] = useState(false)

  const [presentToast] = useIonToast()

  const save = () => {
    setSaving(true)
    props.reportsService
      .editReport({
        ...props.reportEdition,
        report_id: props.reportEdition.reportID,
        status: ReportStatus.back_to_review,
        back_to_review_message: editState.back_to_review_message as string,
      })
      .then(() => {
        props.modal.current?.dismiss({ wasEdited: true })
      })
      .catch((message) => {
        presentToast({
          message,
          duration: 5000,
          color: 'danger',
        })
      })
      .finally(() => setSaving(false))
  }

  useEffect(() => {
    setEditState(() => reportToTypeaheadItem(props.reportEdition) as ModalEditReportHeaderState)
  }, [props.reportEdition])

  return (
    <>
      <IonContent className="ion-padding modal-report-issue">
        <ModalTitle icon={warningOutline} label={props.headerTitle} />
        <div className="free-text-input">
          <span>What is the issue?</span>
          <IonInput
            value={editState.back_to_review_message}
            onIonInput={(e) =>
              setEditState((s) => ({ ...s, back_to_review_message: e.target.value } as ModalEditReportHeaderState))
            }
            placeholder="-"
          />
        </div>
      </IonContent>

      <IonFooter>
        <IonToolbar>
          <IonButton slot="end" fill="outline" onClick={() => {
            props.modal.current?.dismiss({ wasEdited: false })
          }}>
            Cancel
          </IonButton>

          <IonButton
            slot="end"
            fill="solid"
            onClick={() => save()}
            disabled={isSaving}
          >
            {isSaving ? <IonSpinner /> : 'Send to Reviewer'}
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </>
  )
}

export default ModalReportIssue
